// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__hi6hd","blog_contents":"styles_blog_contents__S9O1v"};